export class OrganizationGoal {
  public id: string;
  public class: string;
  public name: string;

  constructor(data: Partial<OrganizationGoal> = {}) {
    this.id = data?.id ?? '';
    this.class = data?.class ?? '';
    this.name = data?.name ?? '';
  }

  public static createFromApi(data: any = {}): OrganizationGoal {
    return new OrganizationGoal({
      id: data?.id ?? '',
      class: data?.class ?? '',
      name: data?.name ?? data?.title ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      id: this.id,
      title: this.name,
    };
  }
}
